<template lang="pug">
b-modal#addLeaderboard(
  ref="addLeaderboard"
  :title="$t('ui.combine.add_leaderboard')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-card
      div.row
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.name')").mb-1
            DebounceInput(
              ref="leaderboard_campaign_name"
              size="sm"
              required
              type="text"
              :dirty="$v.leaderboard_campaign_name.$dirty"
              :error="$v.leaderboard_campaign_name.$error"
              v-model.trim.lazy="$v.leaderboard_campaign_name.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.leaderboard_campaign_name" :name="$t('ui.name')")
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.start_date')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="start_date"
                :config="localeDate"
                :dirty="$v.start_date.$dirty"
                :error="$v.start_date.$error"
                v-model.trim.lazy="$v.start_date.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.end_date')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="end_date"
                :config="localeDate"
                :dirty="$v.end_date.$dirty"
                :error="$v.end_date.$error"
                v-model.trim.lazy="$v.end_date.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.capacity')").mb-0
            DebounceInput(
              size="sm"
              ref="capacity"
              required
              type="number"
              :dirty="$v.capacity.$dirty"
              :error="$v.capacity.$error"
              v-model.trim.lazy="$v.capacity.$model"
              :disabled="loading"
              keyPressRestrict="restrictOnlyNumber"
            )
            ValidateResult(:value="$v.capacity" :name="$t('ui.capacity')" :fvalue="'0'")
      .row
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.criteria')").mb-0
            LbCriteriaLookup(
              size="sm"
              ref="criteria"
              required
              type="array"
              :dirty="$v.criteria.$dirty"
              :error="$v.criteria.$error"
              v-model.trim.lazy="$v.criteria.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')" )
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.reward_type')").mb-0
            LbRewardTypeLookup(
              size="sm"
              ref="reward_type"
              required
              type="array"
              :dirty="$v.reward_type.$dirty"
              :error="$v.reward_type.$error"
              v-model.trim.lazy="$v.reward_type.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.reward_type" :name="$t('ui.reward_type')" )
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.reward_count')").mb-0
            b-form-select(
              size="sm"
              :class="{ 'is-invalid': $v.reward_count.$dirty == true && $v.reward_count.$error == true, 'is-valid': $v.reward_count.$dirty == true && $v.reward_count.$error == false }"
              v-model.trim.lazy="$v.reward_count.$model"
              :disabled="loading"
            )
              option(v-for="i in 5" :value="i") {{ i }}
            ValidateResult(:value="$v.reward_count" :name="$t('ui.reward_count')" )
        div.col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.campaign_id')" v-if="['INBOX'].includes(reward_type)").mb-0
            CampaignLookup(
              size="sm"
              ref="campaign_id"
              required
              type="array"
              :dirty="$v.campaign_id.$dirty"
              :error="$v.campaign_id.$error"
              v-model.trim.lazy="$v.campaign_id.$model"
              :disabled="loading"
              :operatorID="operatorID"
            )
            ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
      .row(v-if="reward_type != ''")
        div.col-sm-12.col-md-12.col-lg-12
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="20%") #
                  th.text-center(v-if="['INBOX','CREDIT'].includes(reward_type)") {{ $t('ui.cash') }}
                  th.text-center(v-if="['PRIZE'].includes(reward_type)") {{ $t('ui.prize') }}
              tbody
                tr(v-for="x in Number(this.reward_count)")
                  td.text-center {{ x }}
                  td(v-if="['INBOX','CREDIT'].includes(reward_type)")
                    div.d-flex.justify-content-center.align-items-center
                      DebounceInput.text-center(
                        size="sm"
                        :ref="'cash_' + x"
                        required
                        type="number"
                        :dirty="$v.formCash['cash_' + x].$dirty"
                        :error="$v.formCash['cash_' + x].$error"
                        v-model="formCash['cash_' + x]"
                        :disabled="loading"
                        @input="$v.formCash['cash_' + x].$touch()"
                      )
                  td(v-if="['PRIZE'].includes(reward_type)")
                    div.d-flex.justify-content-center.align-items-center
                      DebounceInput.text-center(
                        size="sm"
                        :ref="'prize_' + x"
                        required
                        type="text"
                        :dirty="$v.formPrize['prize_' + x].$dirty"
                        :error="$v.formPrize['prize_' + x].$error"
                        v-model="formPrize['prize_' + x]"
                        :disabled="loading"
                        @input="$v.formPrize['prize_' + x].$touch()"
                      )
                tr(v-if="hasCashErrors || hasPrizeErrors")
                  td
                  td(colspan="2")
                    ul.text-danger.small.mb-0
                      li(v-for="(val, key) in $v.formCash" v-if="val.$error") {{ $t('error.cashInvalid', { key }) }}
                      li(v-for="(val, key) in $v.formPrize" v-if="val.$error") {{ $t('error.prizeInvalid', { key }) }}
    b-card
      div.row
        div.col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 20vh;").mb-0
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              tr
                th.text-center.col-checkbox(colspan=3)
                  .d-flex
                    .custom-checkbox.custom-control
                      input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                      label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                    template(v-for="(cat, index) in providerCatList")
                      .custom-checkbox.custom-control
                        input.custom-control-input(
                          type="checkbox"
                          :id="'all-' + cat.toLowerCase()"
                          v-model="allSelected[index + 1]"
                          @change="selectAll(index + 1,$event)"
                          :disabled="loading"
                        )
                        label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
              tr(v-for="(row, rowIndex) in rowsPList" :key="rowIndex")
                td.col-checkbox(v-for='(p, itemIndex) in row' :key="itemIndex")
                  b-form-checkbox(v-model="provider_list" :value='p.value') {{ p.text }}

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CampaignLookup from "@/library/CampaignLookup";
import LbCriteriaLookup from "@/library/LbCriteriaLookup";
import LbRewardTypeLookup from "@/library/LbRewardTypeLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CampaignLookup,
    LbCriteriaLookup,
    LbRewardTypeLookup
  },
  // props: {
  //   item: {
  //     type: Object
  //   },
  // },
  data() {
    return {
      leaderboard_campaign_name: '',
      start_date: this.$moment(new Date).format('YYYY-MM-DD'),
      end_date: this.$moment(new Date).format('YYYY-MM-DD'),
      capacity: '',
      criteria: '',
      reward_type: '',
      reward_count: '1',
      campaign_id: "",
      formPrize: {},
      formCash: {},
      provider_list: [],
      providerList: [],
      allSelected: {},
      providerCatList: [],
      prefixMap: {},
      loading: false,
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    hasPrizeErrors() {
      return Object.values(this.$v.formPrize).some(v => v.$error);
    },
    hasCashErrors() {
      return Object.values(this.$v.formCash).some(v => v.$error);
    },
    rowsPList() {
      const rows = [];
      for (let i = 0; i < this.providerList.length; i += 3) {
        rows.push(this.providerList.slice(i, i + 3));
      }
      return rows;
    },
  },
  validations() {
    const formCashValidations = {};
    const formPrizeValidations = {};
    for (let i = 1; i <= Number(this.reward_count); i++) {
      formCashValidations[`cash_${i}`] = {
        required: requiredIf(function () {
          return ['INBOX','CREDIT'].includes(this.reward_type);
        }),
        mustMoreThanOrEqual: function(value) {
          if(parseFloat(value) < 0) return false
          return true
        }
      };
    }
    for (let i = 1; i <= Number(this.reward_count); i++) {
      formPrizeValidations[`prize_${i}`] = {
        required: requiredIf(function () {
          return ['PRIZE'].includes(this.reward_type);
        }),
        maxLength: maxLength(500)
      };
    }
    return {
      formCash: formCashValidations,
      formPrize: formPrizeValidations,
      leaderboard_campaign_name: {
        required,
        maxLength: maxLength(50)
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      capacity: {
        required,
        mustMoreThan: function(value) {
          if(parseFloat(value) <= 0) return false
          return true
        }
      },
      criteria: {
        required
      },
      reward_type: {
        required
      },
      reward_count: {
        required
      },
      campaign_id: {
        required: requiredIf(function () {
          return ['INBOX'].includes(this.reward_type);
        })
      },
      provider_list: {
        minLength: minLength(1),
      }
    }
  },
  watch : {
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.providerList.length && this.providerList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.providerList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    },
  },
  methods: {
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.providerList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.providerList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_code.toUpperCase(), text: list[i].provider_name, checked: false, category: list[i].category});
                  }
                  this.providerList = result;
                } else {
                  this.providerList = [];
                }

                this.setCategory();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.leaderboardCampaignAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          leaderboard_campaign_name: this.leaderboard_campaign_name,
          start_date: this.start_date,
          end_date: this.end_date,
          capacity: this.capacity,
          criteria: this.criteria,
          reward_type: this.reward_type,
          reward_count: this.reward_count,
          campaign_id: this.campaign_id,
          capacity: this.capacity
        };

        for(var x = 1; x <= this.reward_count; x++) {
          if(this.reward_type == 'CREDIT' || this.reward_type == 'INBOX')
            json['cash_' + x] = this.formCash['cash_' + x]

          if(this.reward_type == 'PRIZE')
            json['prize_' + x] = this.formPrize['prize_' + x]
        }

        if (this.provider_list.length != this.providerList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addLeaderboard.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_leaderboard", this.feedback.status);
                  this.$refs.addLeaderboard.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.leaderboard_campaign_name = ''
      this.start_date = this.$moment(new Date).format('YYYY-MM-DD')
      this.end_date = this.$moment(new Date).format('YYYY-MM-DD')
      this.capacity = ''
      this.criteria = ''
      this.reward_type = ''
      this.reward_count = '1'
      this.campaign_id = ""
      this.formPrize = {}
      this.formCash = {}
      this.provider_list = []
      this.providerList = []
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.$set(this.allSelected, 0, false)
      this.getProviderList();
      this.$v.$reset();
      this.$refs.leaderboard_campaign_name.$el.focus();
    }
  }
};
</script>
